import { Modal, QRCode } from "antd";

interface OrderQrModalProps {
    open: boolean;
    onClose: () => void;
    orderCode: string;
    detailUrl: string;
}

export default function OrderQrModal({
    open,
    onClose,
    orderCode,
    detailUrl,
}: OrderQrModalProps) {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            centered
            width={420}
            title={`Mã QR đơn hàng #${orderCode}`}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 16,
                    padding: "8px 0 12px",
                }}
            >
                <QRCode value={detailUrl} size={220} />

                <p
                    className="MuiTypography-root MuiTypography-body2"
                    style={{
                        margin: 0,
                        textAlign: "center",
                        color: "#5f6368",
                        lineHeight: "20px",
                    }}
                >
                    Quét mã để mở nhanh trang chi tiết đơn hàng.
                </p>

                <a
                    href={detailUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="MuiTypography-root MuiTypography-body2"
                    style={{
                        textAlign: "center",
                        color: "var(--primary-color)",
                        wordBreak: "break-all",
                    }}
                >
                    {detailUrl}
                </a>
            </div>
        </Modal>
    );
}